import { type FunctionComponent, type ReactNode } from "react";
import { useLocation } from "react-router";
import { AppSider } from "~/components/app-sider/app-sider";
import { AppHeader } from "~/components/header/app-header";
import { Toaster } from "~/components/ui";
import { useIsAppSiderCollapsed, useThemeMode, useToggleAppSiderCollapse } from "~/store/ui-preferences.store";

interface ScreenProps {
  children: ReactNode;
  sider?: ReactNode;
}

export const Screen: FunctionComponent<ScreenProps> = ({ children, sider }) => {
  const { pathname } = useLocation();
  const isAppSiderCollapsed = useIsAppSiderCollapsed();
  const toggleAppSiderCollapse = useToggleAppSiderCollapse();
  const shouldOverlay = pathname === "/";
  const themeMode = useThemeMode();

  return (
    <div className="flex h-screen flex-col bg-noa-inset">
      <header className="h-14 shrink-0 border-b border-noa bg-noa px-3 sm:h-20 sm:px-6 dark:bg-noa-elevated">
        <AppHeader isAppSiderCollapsed={isAppSiderCollapsed} toggleAppSiderCollapse={toggleAppSiderCollapse} />
      </header>

      <div className="relative flex min-h-0 flex-1 overflow-hidden">
        <AppSider isCollapsed={isAppSiderCollapsed} overlay={shouldOverlay} onClose={toggleAppSiderCollapse} />
        {sider}
        <main className="min-w-0 flex-1 overflow-hidden bg-noa-inset">{children}</main>
      </div>

      <Toaster theme={themeMode} />
    </div>
  );
};
